import { Box, Typography } from "@mui/material";

//This component is responsible for rendering the goals static text. 
export default function GoalsStaticText() {
    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold'}}>Define Your Career Goals</Box>
            </Typography>
            <Typography variant="body1" component="div" sx={{mt:1, mb:1, width: "60%", minWidth: 255 }}>
                What are your potential career plans? Describe your short and long term goals.
                It is suggested that you include the following:
                <ol>
                    <li>Electives or Individualized curriculum that may help you reach your goals.</li>
                    <li>Obstacles or challenges you foresee.</li>
                    <li>Additional steps you will take to formalize your career plans.</li>
                    <li>Potential mentors that may be needed.</li>
                </ol>
            </Typography>
        </>
    );
}